import styled from "styled-components";

export const Container = styled.main``;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
`;

export const ContentInfor = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const Infor = styled.p`
    display: flex;
    gap: 5px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    
    span{
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-weight: 500;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    
`;

export const Section = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const FeaturedSection = styled.div`
    display: flex;
    justify-content: space-between;

    padding: 10px;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const ContentBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const InforBody = styled.p`
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    
    span{
        color: ${(props) => props.theme.colors.gray.gray_500};
    }
    `;

export const Description = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    text-align: justify;
`;